import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { asyncRoutes, constantRoutes } from '@/router';
import { getAsyncRoutes } from "../../api/role";
import { deepClone } from "../../utils/index";
var clientRoutes = deepClone(asyncRoutes);
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}
function makePermissionRouters(serverRouter, clientAsyncRoutes) {
  console.log(1, clientAsyncRoutes);
  clientAsyncRoutes.map(function (ele) {
    if (!ele.name || !ele.meta && !ele.meta.roles) {
      return;
    }
    var roles_obj;
    for (var i = 0; i < serverRouter.length; i++) {
      var element = serverRouter[i];
      if (ele.name === element.name) {
        roles_obj = element;
      }
    }
    if (roles_obj) {
      ele.meta.roles = roles_obj.roles;
    }
    if (ele.children) {
      makePermissionRouters(serverRouter, ele.children);
    }
  });
  return clientAsyncRoutes;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRouter(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles);
        if (tmp.children.length === 0) {
          return false;
        }
      }
      res.push(tmp);
    }
  });
  return res;
}
export function filterAsyncRouterExcludeNames(routes, exclude_names) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    // console.log(tmp)
    var f = exclude_names.indexOf(tmp.name);
    // console.log(tmp.name)
    // console.log(f)
    if (f < 0) {
      if (tmp.children) {
        tmp.children = filterAsyncRouterExcludeNames(tmp.children, exclude_names);
        if (tmp.children.length === 0) {
          return false;
        }
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function () {
    var _generateRoutes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, roles) {
      var commit, PermissionRouters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return getAsyncRoutes().then(function (res) {
              var data = res;
              PermissionRouters = makePermissionRouters(data, clientRoutes);
              // console.log('api:' + PermissionRouters)
              return PermissionRouters;
            });
          case 3:
            PermissionRouters = _context.sent;
            console.log('permission routers', PermissionRouters);
            return _context.abrupt("return", new Promise(function (resolve) {
              var accessedRoutes;
              if (roles.includes('admin')) {
                // accessedRoutes = PermissionRouters || []
                var accessedRoutes1 = PermissionRouters || [];
                accessedRoutes = filterAsyncRouterExcludeNames(accessedRoutes1, ['adminRemittanceLayout']);
                console.log('permission routers', accessedRoutes);
              } else {
                accessedRoutes = filterAsyncRouter(PermissionRouters, roles);
              }
              commit('SET_ROUTES', accessedRoutes);
              resolve(accessedRoutes);
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function generateRoutes(_x, _x2) {
      return _generateRoutes.apply(this, arguments);
    }
    return generateRoutes;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};